import React from 'react';
import { 
    Container,
    // Row,
    // Col,
} from 'reactstrap';

function FoodMenu () {

    return (
    <>
    <div className="section section-team text-center" id="food-menu-section">
        <Container>
            <h2 className="title">Menu</h2>
            <img
                alt="Menu"
                className="img-fluid img-raised"
                src={require('assets/img/printed_menu.jpg')}
            ></img>
            <hr />
            {/* <div className="team">
                <Row>
                    <Col md="4">
                        <img
                            alt="item 1"
                            className="rounded-circle img-fluid img-raised"
                            src={require('assets/img/polaoroastunda.jpg')}
                        ></img>
                        <h4 className="title">Item 1</h4>
                        <p className="category text-info"> $00.00</p>
                        <p className="description">here goes some description text</p>
                    </Col>
                    <Col md="4">
                        <img
                            alt="item 1"
                            className="rounded-cirecle img-fluid img-raised"
                            src={require('assets/img/chomchom.jpg')}
                        ></img>
                        <h4 className="title">Item 2</h4>
                        <p className="category text-info"> $00.00</p>
                        <p className="description">here goes some description text</p>
                    </Col>
                    <Col md="4">
                        <img
                            alt="item 1"
                            className="rounded-cirecle img-fluid img-raised"
                            src={require('assets/img/curd.jpg')}
                        ></img>
                        <h4 className="title">Item 3</h4>
                        <p className="category text-info"> $00.00</p>
                        <p className="description">here goes some description text</p>
                    </Col>
                </Row>
            </div> */}
        </Container>
    </div>
    </>
    );
}

export default FoodMenu;